// src/components/FileAuthModal.tsx
import React, { useState } from "react";
import "./FileAuthModal.scss";

interface FileAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAuthenticate: (login: string, password: string) => Promise<void>;
  isLoading?: boolean;
  error?: string | null;
}

const FileAuthModal: React.FC<FileAuthModalProps> = ({
  isOpen,
  onClose,
  onAuthenticate,
  isLoading = false,
  error,
}) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (login.trim() && password.trim()) {
      await onAuthenticate(login.trim(), password);
    }
  };

  const handleClose = () => {
    setLogin("");
    setPassword("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="file-auth-modal-overlay" onClick={handleClose}>
      <div className="file-auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="file-auth-modal-header">
          <div className="file-auth-modal-title">File Access Required</div>
          <button
            className="file-auth-modal-close"
            onClick={handleClose}
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="file-auth-modal-form">
          <div className="input">
            {/*<label htmlFor="login">Login:</label>*/}
            <input
              id="login"
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              disabled={isLoading}
              required
              autoFocus
              placeholder="Login"
            />
          </div>

          <div className="input">
            {/*<label htmlFor="password">Password:</label>*/}
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              required
              placeholder="Password"
            />
          </div>

          {error && <div className="file-auth-modal-error">{error}</div>}

          <div className="file-auth-modal-actions">
            <button
              type="button"
              onClick={handleClose}
              disabled={isLoading}
              className="file-auth-modal-cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading || !login.trim() || !password.trim()}
              className="btn-black"
            >
              {isLoading ? "Authenticating..." : "Access File"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FileAuthModal;
